export function gTag(...args: any[]) {
  window?.gtag?.(...args);
}
